import { GraduationCap, Code } from "lucide-react";

const services = [
  {
    id: 1,
    icon: Code,
    title: "SolidWorks API Development",
    description: "Custom macros, plugins, and enterprise solutions using SolidWorks API. VB.NET and C# development for automation, feature recognition, and workflow optimization."
  },
  {
    id: 2,
    icon: Code,
    title: "NXOpen Plugin Development",
    description: "Advanced NX/NXOpen applications for design automation, CAM integration, and manufacturing workflow optimization. C++ and C# expertise."
  },
  {
    id: 3,
    icon: Code,
    title: "devDept Eyeshot Solutions",
    description: "3D CAD visualization and manipulation using devDept Eyeshot. Custom viewers, cloud-based CAD solutions, and rendering applications."
  },
  {
    id: 4,
    icon: Code,
    title: "AutoCAD & Inventor Customization",
    description: "AutoCAD .NET, LISP scripting, and Inventor API development for advanced automation and custom tool development."
  },
  {
    id: 5,
    icon: GraduationCap,
    title: "CAD API Training Programs",
    description: "Comprehensive training covering SolidWorks API, NXOpen, Eyeshot, and AutoCAD automation with hands-on projects and enterprise-scale solutions."
  },
  {
    id: 6,
    icon: Code,
    title: "Legacy Code Migration",
    description: "Modernize VB.NET and legacy code to C#. API version upgrades and platform migrations for smooth transitions."
  }
];

const ServicesSection = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-20 lg:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2
            data-testid="services-title"
            className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0F172A]"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Our Services
          </h2>
          <p className="mt-4 text-lg text-[#0F172A]/60 max-w-2xl mx-auto">
            Empowering engineers and designers with cutting-edge CAD/CAM solutions and expertise
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <div
              key={service.id}
              data-testid={`service-card-${service.id}`}
              className="service-card bg-white border border-slate-200 rounded-2xl p-8 hover:border-[#06B6D4]/30"
            >
              {/* Icon */}
              <div className="w-14 h-14 rounded-xl bg-[#F8FAFC] flex items-center justify-center mb-6">
                <service.icon className="w-7 h-7 text-[#06B6D4]" />
              </div>

              {/* Content */}
              <h3
                className="text-xl font-semibold text-[#0F172A] mb-3"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                {service.title}
              </h3>
              <p className="text-[#0F172A]/60 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
